import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver acknowledged a dispatched message.
 */
export const messageAcknowledgedV1 = tmsEventKind(
  { category: "acknowledgement", kind: "messageAcknowledged", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      /** The vendor's own title for the message, shown as the vendor sends it. */
      messageTitle: z.string(),
    },
  },
);

export const MessageAcknowledgedV1Schema = messageAcknowledgedV1.schema;
export const MessageAcknowledgedV1FactsSchema = messageAcknowledgedV1.facts;

export type MessageAcknowledgedV1 = z.infer<typeof MessageAcknowledgedV1Schema>;
export type MessageAcknowledgedV1Facts = z.infer<typeof MessageAcknowledgedV1FactsSchema>;

/** Every version of `messageAcknowledged`, keyed by version. What `catalog.ts` places under `acknowledgement`. */
export const messageAcknowledged = { 1: messageAcknowledgedV1 } as const;
